import {
  Button,
  Flex,
  Group,
  NumberFormatter,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import MainTable from "../../../../../layouts/Table/MainTable";
import ItemDeleter from "../../../../../components/TableComponents/ItemDeleter";
import { useContactHandler } from "../../components/useContactHandler";
import { IconArrowBarUp, IconUsers } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import {
  deleteBlacklistData,
  deleteBlacklistDatas,
  findBlacklist,
  getFirstPageBlacklist,
  searchInBlacklist,
} from "../../../../../api/BlacklistAPI";
import { useConfigStore } from "../../../../../stores/ConfigStore";
import SelectionDeleter from "../../../../../components/TableComponents/SelectionDeleter";
import TableFilterExport from "../../../../../components/TableComponents/TableFilterExport";
import { downloadFilterList } from "../../../../../api/BlacklistAPI";
import ListName from "../contacts/ListName";
import dateColumn from "../../../../../layouts/Table/columns/dateColumn";
import numberColumn from "../../../../../layouts/Table/columns/numberColumn";

function resultsHandler(response) {
  const datafields = useConfigStore.getState().datafields;
  let results = response;

  return results.map((data) => {
    let current_field = datafields.find((x) => x.id === data.data_field_id);

    if (current_field) {
      return {
        ...data,
        [current_field.id]: data.value,
      };
    }
    return {
      ...data,
    };
  });
}

const BlacklistsContent = ({ list }) => {
  const lang = useLanguage((s) => s.language);
  const apiRef = useGridApiRef();
  const [loadProfile, setLoadProfile] = useState(false);
  const [currentList, setCurrentList] = useState(list);

  const startingColumns = useMemo(() => [numberColumn()], []);
  const {
    loading,
    columns,
    rows,
    rowCount,
    handleLoading,
    onFilterChange,
    onPaginationChange,
    onSortChange,
  } = useContactHandler({
    apiRef,
    listId: parseInt(list?.id),
    getFirstPage: getFirstPageBlacklist,
    searchFunction: searchInBlacklist,
    disableQueryTransform: true,
    resultsHandler,
    startingColumns,
  });

  const actionsCell = useCallback(
    ({ row, value }) => {
      return (
        <ItemDeleter
          title_bold={`#${row.id}`}
          handleDelete={deleteBlacklistData}
          deletedMessage={lang.blacklists.delete_success}
          parentId={currentList?.id}
          id={row.id}
          apiRef={apiRef}
        />
      );
    },
    [lang.blacklists.delete_success, currentList?.id, apiRef]
  );

  const toolbarActions = useCallback(
    ({ selectedIds, filter }) => (
      <>
        <TableFilterExport
          id={currentList?.id}
          selectedIds={selectedIds}
          filter={filter}
          handleExport={downloadFilterList}
          name={currentList?.name}
          filterResultNumber={rowCount}
          total={currentList?.number_of_contacts}
        />
        <SelectionDeleter
          handleMultipleDelete={deleteBlacklistDatas}
          apiRef={apiRef}
          setTableLoading={() => handleLoading()}
          ids={selectedIds}
        />
      </>
    ),
    [
      apiRef,
      currentList?.id,
      currentList?.name,
      currentList?.number_of_contacts,
      handleLoading,
      rowCount,
    ]
  );

  useEffect(() => {
    if (loadProfile) {
      findBlacklist(currentList?.id)
        .then((response) => {
          setCurrentList(response.data.blacklist_profile);
        })
        .finally(() => setLoadProfile(false));
    }
  }, [currentList, loadProfile]);

  if (!columns) {
    return;
  }

  return (
    <Stack h={"100%"} flex={1} pr={16} gap={8} pt={12} miw={950}>
      <Group mt={4}>
        <Text fw={700} fz={24}>
          {lang.prospects.blacklist_contacts}
        </Text>

        <Tooltip label={lang.prospects.blacklist_import_tooltip}>
          <Button
            leftSection={<IconArrowBarUp size={24} fill="#fff" stroke={0} />}
            fz={16}
            ml={"auto"}
            radius={"md"}
            size="md"
            className="main-list-action"
            px={24}
            component={Link}
            variant="outline"
            to={`/blacklists/${currentList?.id}/import`}
          >
            {lang.prospects.import}
          </Button>
        </Tooltip>
      </Group>

      <Group mt={0}>
        <ListName
          currentList={currentList}
          onRenamed={() => setLoadProfile(true)}
          isBlacklist
        />

        <Group>
          <ThemeIcon variant="light" color="primary" size={"md"}>
            <IconUsers size={18} />
          </ThemeIcon>

          <NumberFormatter
            thousandSeparator=" "
            value={currentList?.number_of_data}
          />
        </Group>
      </Group>

      <Flex h={0} flex={1} mt={10}>
        <MainTable
          isClient={false}
          apiRef={apiRef}
          columns={columns}
          rows={rows}
          rowCount={rowCount}
          loading={loading}
          setLoading={() => {
            handleLoading();
          }}
          id={"list-table"}
          hasFolder
          // pageName={"contact_lists_contacts"}
          onPaginationChange={onPaginationChange}
          actionsCell={actionsCell}
          onFilterChange={onFilterChange}
          onSortChange={onSortChange}
          // pageOrderName="contact_list_fetch_contacts_order"
          actionsCellWidth={50}
          withBorderTop
          whiteButtons
          toolbarActions={toolbarActions}
          defaultSort={[{ field: "id", sort: "desc" }]}
          tableSx={{
            overflow: "hidden",
            "& .MuiDataGrid-pinnedColumns": {
              background: "#fff",
              borderTopLeftRadius: 3,
            },
            "& .MuiDataGrid-pinnedColumnHeaders": {
              background: "#fff",
            },
            "& .table-search": {
              width: "300px !important",
            },
          }}
        />
      </Flex>
    </Stack>
  );
};

export default BlacklistsContent;
